<span [matTooltip]="tooltip" [matTooltipPosition]="'below'" [matTooltipDisabled]="!isInThousands">
  <ng-container *ngIf="isInThousands">{{ prefix }}{{ getFormattedValue(value) }}{{ suffix }}</ng-container>
  <ng-content *ngIf="!isInThousands"></ng-content>
</span>
